import moment from 'moment'

export const entryMap2Entries = entryMap => Object.entries(entryMap).map(([label, bars]) => {
  return { label: moment(label), bars }
})
